<template>
  <div>
       <v-progress-linear
          v-if="$vuetify.loading"
          color="primary"
          indeterminate
        ></v-progress-linear>
    <router-view></router-view>

  </div>
</template>

<script>

import SnackBar from "@/components/common/SnackBar";
export default {
  name: 'App',
  components: {SnackBar},
  data: () => ({
    //
  }),
};
</script>
